// Unpublished Work © 2025 Deere & Company. All Worldwide Rights Reserved.

import {enqueueToaster} from '@deere/isg.component-library';
import {TOAST_TYPE} from '../constants/toast-constants';

const addToast = (toastOptions) => {
    const {
        message,
        title,
        type = TOAST_TYPE.INFO,
        persist = false,
        closeable = true,
        ...otherOptions
    } = toastOptions;

    return enqueueToaster(
        message,
        title,
        {
            variant: type,
            isPersistent: persist,
            isCloseable: closeable,
            ...otherOptions
        }
    );
};

export function useToast() {
    return {
        addToast
    };
}
